import { connect } from 'react-redux';
import { getPublicSession } from '../../publicSession/selectors';
import { attemptSocialLogin } from '../redux/actions';
const mapStateToProps = (state)=>{
    var _getPublicSession_appIds;
    return {
        appId: ((_getPublicSession_appIds = getPublicSession(state).appIds) === null || _getPublicSession_appIds === void 0 ? void 0 : _getPublicSession_appIds.facebookAppId) || ''
    };
};
const mapDispatchToProps = {
    attemptSocialLogin
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=SocialButtonFacebook.container.js.map